//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { Auth } from 'aws-amplify';

import curalateModule from 'app/curalate.module';

/**
 * This service merely provides Aws-Amplify modules via Angularjs Dependency injection for easier unit testing.
 */
curalateModule.service('AmplifyService', () => {
  // TODO: Should we also wrap async method with `$q.when`?
  return {
    Auth,
  };
});

export interface IAmplifyService {
  Auth: typeof Auth;
}
